import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import InputPokemons from '../components/InputPokemons.jsx';
import { logos } from '../utils/logos.js';
import { styles } from '../assets/styles';
import { HistoryPokemon } from '../components/historyPokemon.js';
import '../assets/animations.css';
import StatsButton from '../components/modal/statsButton.js';
import HowToButton from '../components/modal/howToButton.js';
import HistoryButton from '../components/modal/historyButton.js';
import { Footer } from '../components/footer.js';

export default function Classic() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 777);

    return () => clearTimeout(timer);
  }, []);

  return (
    /* BOX CONTAINER */
    <Box sx={styles.container}>
      {/* BOX LOGO 1 */}
      <Box sx={styles.logo1}>
        <a href="/">
          <img className="logoPoke" src={logos.logo1} style={styles.width100} />
        </a>
      </Box>

      {/* LOADING */}
      {loading ? (
        <div style={styles.loading}>
          <div style={styles.loadingText}>Loading POKéMON info...</div>
          <div className="circle" style={styles.loadingCircle} />
        </div>
      ) : (
        <>
          <Box sx={styles.modal}>
            <StatsButton statsKey="stats_classic" />
            <HowToButton />
            <HistoryButton component={HistoryPokemon} />
          </Box>
          {/* BOX LOGO 2 */}
          <Box sx={styles.logo2}>
            <img src={logos.logo2} style={styles.width100} />
          </Box>
          {/* BOX INPUT */}
          <InputPokemons />
        </>
      )}
      <Footer />
    </Box>
  );
}
